export function ConnectWallet() {
  // @ts-expect-error -- w3m-button is a web component registered by @web3modal/wagmi
  return <w3m-button />;
}
